import { render, staticRenderFns } from "./ImagesSelectedModal.vue?vue&type=template&id=b10b9008&"
import script from "./ImagesSelectedModal.vue?vue&type=script&lang=js&"
export * from "./ImagesSelectedModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports